import { twMerge } from 'tailwind-merge';
import TableCell, { type TableCellProps } from '../TableCell';
import { classes, styles } from './utils';

export interface NameLabelCellProps extends TableCellProps {
  name: string;
  label?: string;
}

export default function NameLabelCell({
  className,
  name,
  label,
  onClick,
}: NameLabelCellProps) {
  return (
    <TableCell
      sx={onClick && styles.clickable}
      className={twMerge(
        onClick && classes.clickable,
        label && classes.labeledCell,
        className
      )}
      onClick={onClick}>
      <div className={classes.name}>{name}</div>
      {label && <div className={classes.label}>{label}</div>}
    </TableCell>
  );
}
